import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "reports";

export const generateAccountsReportAsync = async () => {
  const url = `${apiEndpoint}/accounts`;

  const { data } = await http.post(url);
  return data;
};

export const reportService = {
  generateAccountsReportAsync,
};

export default reportService;
